<template>
    <td-dialog
        v-if="dialogColorVisible"
        :before-close="skinDialogClose"
        :visible.sync="dialogColorVisible"
        :width="51 * listSkin.length + 'px'"
        :close-on-click-modal="true"
        :close-on-press-escape="true"
        top="18vh"
        :modal="false"
        :show-close="false"
        @cancel="skinDialogClose"
    >
        <td-button type="text" :key="skinInfo.name" v-for="skinInfo in listSkin" size="small" :disabled="skin === skinInfo.name" @click="handleSetColor(skinInfo.name)">
            <div :class="'skin-' + skinInfo.name" style="width:22px;height:22px;  border:0.5px solid #1863DF;"></div>
        </td-button>
        <span slot="footer"></span>
    </td-dialog>
</template>
<script>
export default {
    computed: {
        skin() {
            return this.$store.state.skin;
        }
    },
    data() {
        return {
            radio1: '',
            dialogColorVisible: false,
            listSkin: [],
            skinDisplay: true
        };
    },
    created() {
        //监听联动事件
        window.vue.$EventBus.$on('eventSkin', menu => {
            this.eventSkin();
        });
        /* 初始化主题信息 */
        this.listSkin = window.skinStyle;
    },
    methods: {
        handleSetColor(color) {
            document.getElementsByTagName('body')[0].className = color;
            this.$store.dispatch('setSkin', color);
        },
        eventSkin() {
            this.dialogColorVisible = true;
        },
        skinDialogClose() {
            this.dialogColorVisible = false;
        }
    }
};
</script>
<style scoped>
.el-button.is-disabled.el-button--text {
    padding: 0;
    border: 2px solid #00cc05;
}
>>> .el-dialog {
    margin-top: 8vh !important;
    margin-right: 2vh !important;
}
>>> .el-dialog__header {
    height: 0;
}
>>> .el-dialog__footer {
    height: 0;
    padding: 0;
    padding-top: 0px !important;
}
>>> .el-button {
    padding: 0;
}
>>> .el-dialog__body {
    padding: 4px;
}
</style>
